import type { SupabaseClient } from "@supabase/supabase-js";
import { supabase } from "@/integrations/supabase/client";
import type { Database, Json } from "@/integrations/supabase/types";

/**
 * Existing public schema inspected on 2026-10-12. This facade narrows the
 * client to attachment reads, the granted soft-delete column and its RPCs.
 * Database policies and the RPCs remain the authority; no schema is changed.
 */
export type ExecutorAttachmentRow = {
  id: string;
  user_id: string;
  storage_path: string;
  original_filename: string;
  mime_sniffed: string | null;
  byte_size: number;
  kind: string | null;
  status: string;
  failure_reason: string | null;
  extracted_text: string | null;
  extracted_meta: Json;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  ingest_attempts: number;
  source: string;
};

type ExecutorDatabase = Pick<Database, "__InternalSupabase"> & {
  public: {
    Tables: {
      executor_attachments: {
        Row: ExecutorAttachmentRow;
        Insert: never;
        Update: { deleted_at?: string | null };
        Relationships: [];
      };
    };
    Views: Record<never, never>;
    Enums: Record<never, never>;
    CompositeTypes: Record<never, never>;
    Functions: {
      executor_attachment_caps: {
        Args: Record<PropertyKey, never>;
        Returns: Json;
      };
      executor_attachment_register: {
        Args: { p_storage_path: string; p_original_filename: string };
        Returns: string;
      };
    };
  };
};

export const executorClient = supabase as unknown as SupabaseClient<ExecutorDatabase>;
